import { render, staticRenderFns } from "./ContravencionalFormDatos.vue?vue&type=template&id=92f0fc70&scoped=true"
import script from "./ContravencionalFormDatos.vue?vue&type=script&lang=js"
export * from "./ContravencionalFormDatos.vue?vue&type=script&lang=js"
import style0 from "./ContravencionalFormDatos.vue?vue&type=style&index=0&id=92f0fc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f0fc70",
  null
  
)

export default component.exports